import Router from './App.svelte';

const app = new Router({
	target: document.body
});

export default app;